export default "__VITE_ASSET__DWkcYqw6__"